module.exports = __webpack_public_path__ + "img/es-ES-add-to-apple-wallet.284ebab.svg";